import { jsx as _jsx } from "react/jsx-runtime";
const STAGE_META = {
    initiation: {
        label: "Initiation",
        bg: "var(--slate-bg)",
        color: "var(--slate)",
    },
    auction_approval: {
        label: "Auction Approval",
        bg: "var(--warn-bg)",
        color: "var(--warn)",
    },
    winner_approval: {
        label: "Winner Approval",
        bg: "var(--stage-winner-approval-bg, #f3e8ff)",
        color: "var(--stage-winner-approval)",
    },
    settlement: {
        label: "Settlement",
        bg: "var(--good-bg)",
        color: "var(--good)",
    },
    closed: {
        label: "Closed",
        bg: "var(--slate-bg)",
        color: "var(--slate)",
    },
};
export function StageChip({ stage, className }) {
    const { label, bg, color } = STAGE_META[stage];
    return (_jsx("span", { className: className, style: {
            display: "inline-flex",
            alignItems: "center",
            padding: "3px 10px",
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            background: bg,
            color,
            whiteSpace: "nowrap",
        }, "aria-label": `Stage: ${label}`, children: label }));
}
/**
 * Derive a CaseStage from flag state.
 * institution flags drive the initiation→auction_approval boundary.
 * marketplace flags drive the auction_approval→winner_approval boundary.
 * The settlement stage begins once winner_approval is completed.
 */
export function deriveCaseStage(flags) {
    if (flags.is_closed)
        return "closed";
    if (flags.hub_ops?.settlement_completed)
        return "closed";
    // Settlement begins once winner_approval is done (institution confirms winner)
    if (flags.institution?.winner_approval_completed || flags.marketplace?.winner_posted_completed) {
        return "settlement";
    }
    // Winner approval stage: bidding has completed, awaiting winner sign-off
    if (flags.marketplace?.bidding_completed)
        return "winner_approval";
    // Auction approval stage: listing is live on the platform
    if (flags.marketplace?.listing_completed)
        return "auction_approval";
    // Auction approval stage: institution has approved the auction setup
    if (flags.institution?.auction_approval_completed)
        return "auction_approval";
    return "initiation";
}
//# sourceMappingURL=StageChip.js.map